import {
  Alert,
  Button,
  MenuItem,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { saveShareholder } from "../service/CompanyDocumentsService";
import { useCompanyDocumentsLanguage } from "../i18n/CompanyDocumentsLanguageContext";

export default function OnboardingShareholderForm({
  record,
  onCancel,
  onSaved,
}) {
  const { t } =
    useCompanyDocumentsLanguage();

  const [data, setData] = useState({
    requirement_type:
      record?.requirement_type || "INDIVIDUAL",
    name: record?.name || "",
  });

  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const change = (key, value) =>
    setData((current) => ({
      ...current,
      [key]: value,
    }));

  const save = async (event) => {
    event.preventDefault();

    setBusy(true);
    setError("");

    try {
      await saveShareholder(record?.id, {
        scope: "FOUNDER",
        requirement_type: data.requirement_type,
        name: data.name,
        email: "",
        phone: "",
        establishment_date: "",
      });

      await onSaved();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form
      onSubmit={save}
      className="grid gap-3 rounded-lg border bg-[#F8FAFC] p-4"
    >
      <h3 className="font-semibold">
        {record
          ? t("client.founder.editTitle")
          : t("client.founder.addTitle")}
      </h3>

      {error && (
        <Alert severity="error">{error}</Alert>
      )}

      <TextField
        select
        size="small"
        label={t("client.founder.type")}
        value={data.requirement_type}
        disabled={busy || Boolean(record)}
        onChange={(event) =>
          change(
            "requirement_type",
            event.target.value,
          )
        }
      >
        <MenuItem value="INDIVIDUAL">
          {t("client.common.individual")}
        </MenuItem>

        <MenuItem value="LEGAL_ENTITY">
          {t("client.common.legalEntity")}
        </MenuItem>
      </TextField>

      <TextField
        size="small"
        required
        label={
          data.requirement_type === "LEGAL_ENTITY"
            ? t("client.founder.legalName")
            : t("client.founder.individualName")
        }
        value={data.name}
        disabled={busy}
        inputProps={{ maxLength: 150 }}
        onChange={(event) =>
          change("name", event.target.value)
        }
      />

      <p className="text-sm text-[#5F737F]">
        {t("client.founder.requirement")}
      </p>

      <div className="flex flex-wrap gap-2">
        <Button
          type="submit"
          variant="contained"
          disabled={busy}
        >
          {record
            ? t("client.founder.saveChanges")
            : t("client.founder.saveNew")}
        </Button>

        <Button
          type="button"
          disabled={busy}
          onClick={onCancel}
        >
          {t("client.common.cancel")}
        </Button>
      </div>
    </form>
  );
}
